import {
  createAxiosKPIs,
  createAxiosHeaders,
  createAxios,
} from "./axiosHttpMarconi";
import { franquiciaService } from "./franquicia.service";

export const dashboardService = {
  getDashboard,
  getNotificationFile,
  getNotifications,
};

function getDashboard(filters) {
  const franquicia = franquiciaService.getLocalFranquicia();
  filters.franquicia = franquicia._id;
  const axios = createAxiosKPIs();
  let urlPath = `dashboard`;
  const params = new URLSearchParams(filters);

  urlPath += `?${params.toString()}`;
  return axios.get(urlPath);
}

function getNotifications() {
  const franquicia = franquiciaService.getLocalFranquicia();
  const axios = createAxios();
  const urlPath = `/franquicia/${franquicia._id}/notificaciones`;
  return axios.get(urlPath).then((data) => {
    if (!Array.isArray(data)) throw new Error("Respuesta de notificaciones no válida");
    return data;
  });
}

function getNotificationFile(notificationId) {
  const axios = createAxiosHeaders();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquicia/${user.extraData.franquiciaId}/notification/${notificationId}/file`;
  return axios
    .get(urlPath)
    .then((response) => {
      const byteCharacters = atob(response.data);
      const byteArrays = [];
      for (let i = 0; i < byteCharacters.length; i++)
        byteArrays.push(byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteArrays);
      const type = response.headers["content-type"];
      return {
        file: new Blob([byteArray], { type }),
        filename: response.headers["content-disposition"],
      };
    })
    .catch(async (error) => {
      if (error instanceof Blob) {
        const data = await error.text();
        try {
          error = JSON.parse(data);
        } catch {
          error = { error: data };
        }
      }
      throw error;
    });
}
